export const getDaysSince = (target_date: string) => {
  const diffMs = Date.now() - new Date(target_date).getTime();
  return Math.floor(Math.max(diffMs / (1000 * 60 * 60 * 24), 0));
};
